@if (data(); as msg) {
    <program-item 
        class="d-inline-block me-2"
        [program]="msg.program"  />
    <span>not found.</span>
}
 